exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".SwitchCm_root_1zYaY{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;margin:auto;border:1px solid #000;border-radius:10px;font-size:small}.SwitchCm_button_2V-Sa{display:block;width:50%;border-radius:10px;padding:5px 15px;color:#333;cursor:pointer}.SwitchCm_active_36ORa{color:#fff;background-color:#000}", ""]);

// exports
exports.locals = {
	"root": "SwitchCm_root_1zYaY",
	"button": "SwitchCm_button_2V-Sa",
	"active": "SwitchCm_active_36ORa"
};